import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IClientPromiseLookupService } from "../IClientPromiseLookupService";
import { ClientAccountVisibilityType } from "../../../model/privatization/clientAccountVisibility/ClientAccountVisibilityType";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { AutoCompleteLabelValuePromiseLookupService } from "./AutoCompleteLabelValuePromiseLookupService";

export abstract class ClientPromiseLookupService
  extends AutoCompleteLabelValuePromiseLookupService<string, CubiqTS.ClientImpl>
  implements IClientPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getClient(
    id: string,
    type?: ClientAccountVisibilityType | null,
  ): Promise<CubiqTS.ClientImpl>;
  abstract lookupClient(namePrefix: string, maxResults: number): Promise<Array<CubiqTS.ClientImpl>>;
  abstract lookupClientsForId(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.ClientImpl>>;
  abstract lookupClientsForName(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.ClientImpl>>;
  /* abstract getBranchCodes():Promise<string[]>; */
  abstract getTradingChannels(): Promise<CubiqTS.TradingChannelProfileImpl[]>;
  abstract getRateSrc(): Promise<CubiqTS.RateSourceImpl[]>;
  abstract getClientContacts(id: string): Promise<CubiqTS.ClientContact[]>;
  abstract getClientContact(id: string): Promise<CubiqTS.ClientContact>;
  // active clients only
  abstract getActiveClient(
    id: string,
    type?: ClientAccountVisibilityType | null,
  ): Promise<CubiqTS.ClientImpl>;
  abstract getActiveClientContacts(id: string): Promise<CubiqTS.ClientContact[]>;
  abstract lookupAFillClientsForId(
    namePrefix: string,
    maxResults: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.ClientImpl>>;
  abstract lookupAFillClientsForName(
    namePrefix: string,
    maxResults: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.ClientImpl>>;
  abstract lookupActiveClientsForId(
    namePrefix: string,
    maxResults: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.ClientImpl>>;
  abstract lookupActiveClientsForName(
    namePrefix: string,
    maxResults: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.ClientImpl>>;

  abstract lookupBMarkClientsForId(
    token: string,
    resultSize: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.ClientImpl>>;
  abstract lookupBMarkClientsForName(
    token: string,
    resultSize: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.ClientImpl>>;
}
